import { Route, Routes, useParams } from 'react-router-dom';

import { Layout } from './layouts/main';
import { Home } from './pages/Home';
import { CardPage } from './pages/CardPage';
import { Catalog } from './pages/Catalog';
import { ArticlePage } from './pages/ArticlePage';
import { NotFoundPage } from './pages/NotFoundPage';
import { CallbackPopup } from './components/CallbackPopup';
import { InfoPopup } from './components/InfoPopup';
import { Privacy } from './pages/Privacy/Privacy';
import ImagePopup from './components/ImagePopup/ImagePopup';
import { ArticlesList } from './pages/ArticlesList';
import { AboutPage } from './pages/AboutPage';
import { ContactsPage } from './pages/ContactsPage';
import { CATALOG_SECTIONS } from './seo/metaConfig';

// Раздел каталога открываем только если он существует: выдуманный адрес
// вида /catalog/что-угодно должен показывать «страница не найдена»,
// а не рабочий каталог с чужим заголовком.
function CatalogSectionRoute() {
  const { section } = useParams();
  // Сверяем строго со своим списком (иначе служебные имена вроде
  // constructor тоже «находятся») и не придираемся к регистру адреса.
  const key = String(section || '').toLowerCase();
  const known = Object.prototype.hasOwnProperty.call(CATALOG_SECTIONS, key);
  return known ? <Catalog /> : <NotFoundPage />;
}

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/articles" element={<ArticlesList />} />
        <Route path="/articles/:id" element={<ArticlePage />} />
        <Route path="/catalog" element={<Catalog />} />
        {/* Разделы каталога: свой адрес и свои Title/Description для поиска */}
        <Route path="/catalog/:section" element={<CatalogSectionRoute />} />
        <Route path="/cards/:id" element={<CardPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <CallbackPopup />
      <InfoPopup />
      <ImagePopup />
    </Layout>
  );
}

export default App;
